// Label dalam bahasa semasa untuk kod teknikal yang dipaparkan kepada pentadbir
// (tindakan audit, peranan, pelaku, nama gateway).

import { t } from '../../core/i18n.js';

export function actionLabel(code) {
  const key = `audit_action.${code}`;
  const v = t(key);
  return v === key ? t('audit_action.OTHER') : v;
}

export function actorLabel(id) {
  if (id === 'SYSTEM') return t('actor.system');
  if (id === 'GATEWAY') return t('actor.gateway');
  return id;
}

export const roleLabel = (r) => t(`role.${r}`);
export const gatewayName = (g) => t(`gateway.${g}`);
